<template>
    <button
        class="uk-button uk-button-small"
        type="button"
        v-on="$listeners"
    >
        <div class="uk-flex uk-flex-middle">
            <div
                v-if="ukIcon.length"
                :uk-icon="ukIcon"
                class="uk-margin-small-right"
            />
            <div>
                {{ label }}
            </div>
        </div>
    </button>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: function () {
                return "Button";
            }
        },
        ukIcon: {
            type: String,
            default: function () {
                return "";
            }
        }
    }
}
</script>
